// import { useState } from "react";
// import "./Contact.css";

// export default function Contact() {
//   const [copied, setCopied] = useState(false);

//   const copy = () => {
//     navigator.clipboard.writeText("sumushakya25@gmail.com");
//     setCopied(true);
//     setTimeout(() => setCopied(false), 2000);
//   };

//   return (
//     <section className="contact section" id="contact">
//       <div className="container">
//         <div className="section-label">
//           <span className="label-line" />
//           <span>Contact</span>
//         </div>

//         <div className="contact-grid">
//           <div className="contact-left">
//             <h2 className="contact-heading">
//               Let's build something
//               <br />
//               <em>great together</em>
//             </h2>
//             <p className="contact-sub">
//               I'm currently open to new opportunities. Whether it's a full-time
//               role, freelance project, or just a chat — my inbox is always open.
//             </p>

//             <div className="contact-links">
//               <a href="mailto:sumushakya25@gmail.com" className="contact-link">
//                 <div className="cl-icon">✉</div>
//                 <div>
//                   <div className="cl-label">Email</div>
//                   <div className="cl-value">sumushakya25@gmail.com</div>
//                 </div>
//                 <span className="cl-arrow">→</span>
//               </a>

//               <a href="tel:9818772059" className="contact-link">
//                 <div className="cl-icon">📞</div>
//                 <div>
//                   <div className="cl-label">Phone</div>
//                   <div className="cl-value">+977 9818772059</div>
//                 </div>
//                 <span className="cl-arrow">→</span>
//               </a>

//               <div className="contact-link location">
//                 <div className="cl-icon">📍</div>
//                 <div>
//                   <div className="cl-label">Location</div>
//                   <div className="cl-value">Natole-20, Lalitpur, Nepal</div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* <div className="contact-right">
//             <div className="contact-card">
//               <div className="cc-top">
//                 <span className="cc-status">
//                   <span className="cc-dot" />
//                   Open to Work
//                 </span>
//                 <span className="cc-type">Full-time · Freelance</span>
//               </div>

//               <h3 className="cc-heading">Send me a message</h3>

//               <div className="cc-email-block">
//                 <span className="cc-email">sumushakya25@gmail.com</span>
//                 <button className="cc-copy" onClick={copy}>
//                   {copied ? '✓ Copied!' : 'Copy'}
//                 </button>
//               </div>

//               <div className="cc-divider">or reach out directly</div>

//               <a href="mailto:sumushakya25@gmail.com" className="cc-btn">
//                 Say Hello 👋
//               </a>

//               <div className="cc-socials">
//                 <a
//                   href="https://github.com"
//                   target="_blank"
//                   rel="noreferrer"
//                   className="social-btn"
//                   title="GitHub"
//                 >
//                   <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//                     <path d="M12 0C5.37 0 0 5.37 0 12c0 5.3 3.44 9.8 8.2 11.38.6.1.82-.26.82-.58 0-.28-.01-1.03-.02-2.03-3.34.72-4.04-1.61-4.04-1.61-.55-1.39-1.34-1.76-1.34-1.76-1.09-.75.08-.73.08-.73 1.2.08 1.84 1.24 1.84 1.24 1.07 1.83 2.81 1.3 3.5 1 .1-.78.42-1.3.76-1.6-2.67-.3-5.47-1.33-5.47-5.93 0-1.31.47-2.38 1.24-3.22-.12-.3-.54-1.52.12-3.18 0 0 1.01-.32 3.3 1.23a11.5 11.5 0 013.01-.4c1.02.005 2.05.14 3.01.4 2.28-1.55 3.29-1.23 3.29-1.23.66 1.66.24 2.88.12 3.18.77.84 1.24 1.91 1.24 3.22 0 4.61-2.81 5.62-5.48 5.92.43.37.81 1.1.81 2.22 0 1.6-.01 2.9-.01 3.29 0 .32.21.69.82.57C20.57 21.8 24 17.3 24 12c0-6.63-5.37-12-12-12z"/>
//                   </svg>
//                   GitHub
//                 </a>
//                 <a
//                   href="https://linkedin.com"
//                   target="_blank"
//                   rel="noreferrer"
//                   className="social-btn"
//                   title="LinkedIn"
//                 >
//                   <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//                     <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.37V9h3.41v1.56h.05c.47-.9 1.63-1.85 3.36-1.85 3.59 0 4.26 2.36 4.26 5.44v6.3zM5.34 7.43a2.06 2.06 0 110-4.12 2.06 2.06 0 010 4.12zm1.78 13.02H3.56V9h3.56v11.45zM22.23 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.46C23.21 24 24 23.23 24 22.28V1.72C24 .77 23.21 0 22.23 0z"/>
//                   </svg>
//                   LinkedIn
//                 </a>
//               </div>
//             </div>
//           </div> */}
//         </div>
//       </div>
//     </section>
//   );
// }

import { useState } from "react";
import "./Contact.css";

export default function Contact() {
  const [copied, setCopied] = useState(false);

  const copy = () => {
    navigator.clipboard.writeText("sumushakya25@gmail.com");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section className="contact section" id="contact">
      <div className="container">
        <div className="contact-center">
          <div className="centered-label">
            <span className="label-line" />
            <span className="label-text">Contact</span>
            <span className="label-line" />
          </div>

          <h1 className="contact-heading">
            Let's build something great <em>together</em>
          </h1>

          <p className="contact-sub">
            I'm currently open to new opportunities — whether it's a full-time
            role, freelance project, or just a friendly chat. Feel free to reach
            out!
          </p>

          <div className="contact-cards">
            <a href="mailto:sumushakya25@gmail.com" className="contact-card">
              <div className="cc-icon-wrap">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="4" width="20" height="16" rx="2" />
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                </svg>
              </div>
              <div className="cc-label">Email</div>
              <div className="cc-value">sumushakya25@gmail.com</div>
            </a>

            <a href="tel:9818772059" className="contact-card">
              <div className="cc-icon-wrap">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.5 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.41 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.4a16 16 0 0 0 5.68 5.68l.76-.76a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 16.92z" />
                </svg>
              </div>
              <div className="cc-label">Phone</div>
              <div className="cc-value">+977 9818772059</div>
            </a>

            <div className="contact-card no-link">
              <div className="cc-icon-wrap">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </div>
              <div className="cc-label">Location</div>
              <div className="cc-value">Lalitpur, Nepal</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
